import { useState } from "react";
import { Container, Snackbar, Alert } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import UserForm from "./UserFormProps";
import { FormValues } from "./types";
import { useNavigate,useLocation } from 'react-router-dom';
import { ApiUrl } from '../App';
import { format } from 'date-fns/fp';

const App = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error",
  });

  const navigate = useNavigate();
  const location = useLocation();
  let email         = location.state.email;
  let access_token  = location.state.access_token;
  console.log(email);
  console.log(access_token);

    const handleSubmit = async (values: FormValues) => {
    try {
      // フォーム送信処理を擬似的に表現
//      await new Promise((resolve) => setTimeout(resolve, 100));
      	console.log(values); // フォームの値をログ出力
        const formData = new URLSearchParams();
        formData.append("email"   ,email);
        formData.append("name" 		,values.personalInfo.name);
        formData.append("name_reading" 	,values.personalInfo.name_reading);
	if ( values.personalInfo.birthDate == null ){
        	formData.append("birthDate" 	,"null");
	}else{
		const formatDate = format('yyyy-MM-dd');
		const sDate = formatDate(values.personalInfo.birthDate as Date);
        	formData.append("birthDate" 	,sDate);
	}
        formData.append("gender" 	,values.personalInfo.gender);
        formData.append("school" 	,values.personalInfo.school);
        formData.append("school_major" 	,values.personalInfo.school_major);
        formData.append("school_grade" 	,values.personalInfo.school_grade);
        formData.append("address" 	,values.personalInfo.address);
        formData.append("tel_no" 	,values.personalInfo.tel_no);
        formData.append("skill" 	,values.personalInfo.skill);
        formData.append("hobby" 	,values.personalInfo.hobby);
        formData.append("blog" 		,values.personalInfo.blog);
        formData.append("games" 	,values.personalInfo.games);
        formData.append("animes" 	,values.personalInfo.animes);
        const body = formData.toString();

        const url = ApiUrl + "users/settings/update";
        console.log(url);

	fetch(url, {
                method: "POST",
                headers:{
                        'Authorization': 'Bearer ' + access_token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                },
                body:  body,
             })
            .then(response => response.json())
            .then(data => {
                    console.log('Success:', data);
                    const fOk: boolean = data.data.success;
                    console.log('Success fOK:', fOk);
                    if ( fOk ) {
      			setSnackbar({
        			open: true,
        			message: "フォームが正常に送信されました！",
        			severity: "success",
      			});
                        console.log('Success OK:', data);
                        navigate('/ended', { state:{
                                message: data.data.message,
                                }})
                    }else{
                        console.log('in Error:', data);
                        console.log('in Error:', data.data.response);
                        navigate('/mes', { state:{
                                message: data.data.response,
                                }})
                    }
            })
            .catch((error) => {
                    console.error('Error:', error);
      			setSnackbar({
        			open: true,
        			message: "エラーが発生しました。",
        			severity: "error",
			})
	    })

    } catch (error) {
      setSnackbar({
        open: true,
        message: "エラーが発生しました。",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

    return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Container maxWidth="sm">
        <UserForm onSubmit={handleSubmit} />
      </Container>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default App;
